<template>
  <el-form ref="form" :model="form" label-width="0px" @submit.native.prevent>
    <div class="side-search-form-box">
      <div class="side-search-form-title">ユーザー名/キーワード検索</div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
        <div class="side-search-form-radio">
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form.radio" :label="1" @change="resetKeyword()">
            ユーザー名
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form.radio" :label="2" @change="resetKeyword()">
            キーワード
            <el-tooltip placement="top" content="名前、プロフィール、投稿内容に含まれるキーワードで検索します。">
              <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
            </el-tooltip>
          </el-radio>
        </div>
        <sidemenuSuggestInfluencer 
          v-show="form.radio == 1" 
          :name.sync="form.account_name" 
          :sns_type="'instagram'"
          @resultCount="resultCount()" 
          @nameSearch="nameSearch()"
        />
        <sidemenuSuggestKeyword 
          v-show="form.radio == 2" 
          :keyword.sync="form.keyword" 
          :sns_type="'instagram'" 
          :exclude_keyword.sync="form.exclude_keyword"
          @resultCount="resultCount()" 
          @search="iSearch()"
        />
      </div>
    </div>

    <div class="side-search-form-box">
      <div class="side-search-form-title">他SNS登録</div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
        <el-radio-group v-model="form.other_sns_type" size="mini" style="margin: 12px 0 0;" @change="resultCount()">
          <el-radio :class="dark_mode ? 'dark' : ''" label="">
            -
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="youtube">
            <font-awesome-icon :icon="['fab', 'youtube']" style="margin-left:4px; font-size:16px"/>
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="tiktok">
            <font-awesome-icon :icon="['fab', 'tiktok']" style="margin-left:4px; font-size:16px"/>
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="twitter">
            <svg width="13" height="13" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                  fill="currentColor"/>
            </svg>
          </el-radio>
        </el-radio-group>
      </div>
    </div>

    <div>
      <div class="side-search-form-box">
        <div class="side-search-form-title">性別</div>
        <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
          <div class="side-search-form-radio" style="margin-bottom:0px">
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form.gender_female" @change="resultCount()">女性
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form.gender_male" @change="resultCount()">男性
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form.gender_other" @change="resultCount()">
              その他
              <el-tooltip placement="top"
                          content="その他：ブランド、ショップ、キャラクター/ペットなどの非人物アカウントです">
                <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
              </el-tooltip>
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-if="activate == 20 && admin_mode" v-model="form.gender_null"
                         @change="resultCount()"></el-checkbox>
          </div>
        </div>
      </div>

      <!-- フォロワー増加率 -->
      <div class="side-search-form-box">
        <div class="side-search-form-title">フォロワー増加率</div>
        <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
          <div class="side-search-form-radio" style="margin-bottom:0">
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form.followers_growth_rate_1" @change="resultCount()">~1.5%</el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form.followers_growth_rate_2" @change="resultCount()">1.5~3%</el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form.followers_growth_rate_3" @change="resultCount()">3~10%</el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form.followers_growth_rate_4" @change="resultCount()">10%~</el-checkbox>
          </div>
        </div>
      </div>

      <div class="side-search-form-title">フォロワー数</div>
      <el-form-item label class="slider">
        <el-slider :class="dark_mode ? 'dark' : ''" v-model="form.followers" @change="resultCount()" :step="5000"
                   name="follower" :marks="follower_marks" range :max="500000"></el-slider>
      </el-form-item>

      <div class="side-search-form-title">EGR</div>
      <el-form-item label class="slider">
        <el-slider
            :class="dark_mode ? 'dark' : ''"
            v-model="form.average_engagement_rate"
            @change="resultCount()"
            :step="0.5"
            name="egr"
            :marks="average_engagement_rate_marks"
            range
            :max="10"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">フォロワー女性比率</div>
      <el-form-item label class="slider">
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form.female_ratio"
            @change="resultCount()"
            :step="5"
            name="gender"
            :marks="female_ratio_marks"
            range
            :max="100"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">年齢</div>
      <el-form-item label>
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form.age"
            @change="resultCount()"
            :step="5"
            name="age"
            :marks="age_marks"
            range
            :min="15"
            :max="55"
            :format-tooltip="ageTooltip"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">SCORE</div>
      <el-form-item label class="slider">
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form.score"
            @change="resultCount()"
            :step="1"
            name="score"
            :marks="score_marks"
            range
            :max="100"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">平均リール再生数</div>
      <el-form-item label class="slider">
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form.average_video_play_count"
            @change="resultCount()"
            :step="1000"
            name="average_video_play_count"
            :marks="average_video_play_count_marks"
            range
            :max="500000"
        ></el-slider>
      </el-form-item>
      <!-- PR率 -->
      <div class="side-search-form-title">PR率</div>
      <el-form-item label class="slider">
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form.pr_rate"
            @change="resultCount()"
            :step="5"
            name="pr_rate"
            :marks="pr_rate_marks"
            range
            :min="0"
            :max="100"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">
        関連エリア
        <el-tooltip placement="top" content="投稿画像やプロフィールから関連エリアを算出します。">
          <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
        </el-tooltip>
      </div>
      <el-form-item>
        <el-cascader
            v-model="form.area"
            :options="sidemenu_option.area_list"
            :show-all-levels="false"
            :props="{ multiple: true }"
            placeholder="エリア選択"
            collapse-tags
            clearable
            @change="resultCount()"
            :class="dark_mode ? 'dark' : ''"
            size="mini"
        ></el-cascader>
      </el-form-item>
      <div class="side-search-form-title">
        関連カテゴリ
        <el-tooltip placement="top" content="投稿画像やキャプション内容から関連カテゴリを算出します。">
          <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
        </el-tooltip>
      </div>
      <el-form-item>
        <el-cascader
            v-model="form.category"
            :options="categoryCascaderOptions"
            :show-all-levels="false"
            :props="{ multiple: true }"
            placeholder="関連カテゴリ"
            collapse-tags
            clearable
            filterable
            @change="resultCount()"
            :class="dark_mode ? 'dark' : ''"
            size="mini"
        ></el-cascader>
      </el-form-item>
      <div class="side-search-form-title">
        <span class="pointer" @click="showDetailOption()"
        >詳細オプション
          <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px;"/>
        </span>
      </div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'" style="margin-bottom:10px"
           v-show="detail_option">
        <div class="side-search-form-title" style="color: #aaa;">レポート実績有無</div>
        <div :class="dark_mode ? 'side-search-form-radio dark' : 'side-search-form-radio'">
          <el-radio-group v-model="form.report_record_status" size="mini" @change="resultCount()">
            <el-radio :class="dark_mode ? 'dark' : ''" :label=0>
              -
            </el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label=1>
              有
            </el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label=2>
              無
            </el-radio>
          </el-radio-group>
        </div>
        <div class="side-search-form-title" style="color: #aaa;">レポート名</div>
        <el-form-item>
          <el-input
              v-model="form.report_keyword"
              class="side-search-form-input"
              :class="[dark_mode ? 'dark' : '', form.report_record_status === 2 ? 'side-search-form-input-disabled' : '']"
              placeholder="レポート名に含まれるキーワード"
              size="mini"
              clearable
              @input="resultCount()"
              :disabled="form.report_record_status === 2"
          ></el-input>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">人物・肩書</div>
        <div class="side-search-form-radio">
          <el-radio-group v-model="form.person_title_search_type" size="mini" @change="resultCount()">
            <el-radio :class="dark_mode ? 'dark' : ''" :label="1">AND検索</el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label="2">OR検索</el-radio>
          </el-radio-group>
        </div>
        <el-form-item>
          <el-cascader
              v-model="form.person_title"
              :options="personTitleCascaderOptions"
              :show-all-levels="false"
              :props="{ multiple: true }"
              placeholder="人物・肩書"
              collapse-tags
              clearable
              filterable
              @change="resultCount()"
              :class="dark_mode ? 'dark' : ''"
              size="mini"
          ></el-cascader>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">得意カテゴリー・ジャンル</div>
        <div class="side-search-form-radio">
          <el-radio-group v-model="form.specialty_categories_genres_search_type" size="mini" @change="resultCount()">
            <el-radio :class="dark_mode ? 'dark' : ''" :label="1">AND検索</el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label="2">OR検索</el-radio>
          </el-radio-group>
        </div>
        <el-form-item>
          <el-cascader
              v-model="form.specialty_categories_genres"
              :options="specialtyCategoriesGenresCascaderOptions"
              :show-all-levels="false"
              :props="{ multiple: true }"
              placeholder="得意カテゴリー・ジャンル"
              collapse-tags
              clearable
              filterable
              @change="resultCount()"
              :class="dark_mode ? 'dark' : ''"
              size="mini"
          ></el-cascader>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">投稿形式</div>
        <div class="side-search-form-radio">
          <el-radio-group v-model="form.post_format_search_type" size="mini" @change="resultCount()">
            <el-radio :class="dark_mode ? 'dark' : ''" :label="1">AND検索</el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label="2">OR検索</el-radio>
          </el-radio-group>
        </div>
        <el-form-item>
          <el-cascader
              v-model="form.post_format"
              :options="postFormatCascaderOptions"
              :show-all-levels="false"
              :props="{ multiple: true }"
              placeholder="投稿形式"
              collapse-tags
              clearable
              filterable
              @change="resultCount()"
              :class="dark_mode ? 'dark' : ''"
              size="mini"
          ></el-cascader>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa; margin-top:5px">フォロワーの年齢層を指定</div>
        <el-form-item>
          <el-select
              clearable
              class="sidemenu-input"
              :class="dark_mode ? 'dark' : ''"
              v-model="form.main_audience"
              @change="resultCount()"
              style="margin-left: 0px;"
              placeholder="フォロワーの年齢層"
              size="mini"
          >
            <el-option label="13-17" value="13_17"></el-option>
            <el-option label="18-24" value="18_24"></el-option>
            <el-option label="25-34" value="25_34"></el-option>
            <el-option label="35-44" value="35_44"></el-option>
            <el-option label="45-54" value="45_54"></el-option>
            <el-option label="55-64" value="55_64"></el-option>
          </el-select>
          <el-slider
              v-if="form.main_audience && form.main_audience.match(/\_/)"
              style="margin-top:5px"
              class="sidemenu-load"
              :class="dark_mode ? 'dark' : ''"
              v-model="form.main_audience_percent"
              @change="resultCount()"
              :step="5"
              name="gender"
              :marks="female_ratio_marks"
              range
              :max="100"
          ></el-slider>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">リストに含まれるインフルエンサーを除外</div>
        <sidemenuCascader
            v-model="form.exclude_list"
            :darkMode.sync="dark_mode"
            :options.sync="sidemenu_option.mylist_instagram"
            @change="resultCount()"
        ></sidemenuCascader>
        <div class="side-search-form-title" style="color: #aaa;">認証バッジの有無</div>
        <el-form-item>
          <el-select
              clearable
              :class="dark_mode ? 'dark' : ''"
              class="sidemenu-input"
              v-model="form.exclude_badge"
              @change="resultCount()"
              style="margin-left: 0px;"
              placeholder="認証バッジの有無"
              size="mini"
          >
            <el-option label="認証バッジ付きのみを表示" value="only"></el-option>
            <el-option label="認証バッジ付きを除外して表示" value="exclude"></el-option>
          </el-select>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">お気に入りの有無</div>
        <el-form-item>
          <el-select clearable :class="dark_mode ? 'dark' : ''" v-model="form.exclude_favorite" @change="resultCount()"
                     style="margin-left: 0px;" placeholder="お気に入りの有無" size="mini">
            <el-option label="お気に入りのみを表示" value="only"></el-option>
            <el-option label="お気に入りを除外して表示" value="exclude"></el-option>
          </el-select>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">カスタマイズタグ</div>
        <div class="side-search-form-radio">
          <el-radio-group v-model="form.tags_search_type" size="mini" @change="resultCount()">
            <el-radio :class="dark_mode ? 'dark' : ''" :label="1">AND検索</el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label="2">OR検索</el-radio>
          </el-radio-group>
        </div>
        <el-form-item>
          <el-cascader
              v-model="form.tags"
              :options="sidemenu_option.tag_list"
              :show-all-levels="false"
              :props="{ multiple: true }"
              placeholder="カスタマイズタグを選択"
              collapse-tags
              clearable
              filterable
              @change="resultCount()"
              :class="dark_mode ? 'dark' : ''"
              size="mini"
          ></el-cascader>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">Webリンク</div>
        <el-form-item>
          <el-input
              v-model="form.weblink"
              class="side-search-form-input"
              :class="dark_mode ? 'dark' : ''"
              placeholder="Webリンクに含まれるキーワード"
              size="mini"
              clearable
              @input="resultCount()"
          ></el-input>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">ストーリーズトラッキングの有無</div>
        <el-form-item class="bottom">
          <el-select clearable :class="dark_mode ? 'dark' : ''" v-model="form.exclude_stories" @change="resultCount()"
                     style="margin-left: 0px;" placeholder="ストーリーズトラッキングの有無" size="mini">
            <el-option label="トラッキング対象のみを表示" value="only"></el-option>
            <el-option label="トラッキング対象を除外して表示" value="exclude"></el-option>
          </el-select>
        </el-form-item>
      </div>
    </div>

    <div class="side-search-form-button" :class="dark_mode ? 'dark' : ''">
      <el-button size="small" @click="resetParams()" style="margin-right:10px;" :type="dark_mode ? 'info' : 'default'"
                 :class="dark_mode ? 'dark' : ''">リセット
      </el-button>
      <div style="display:flex; flex:1">
        <el-button native-type="submit" type="primary" class="sidemenu-load" :class="dark_mode ? 'dark' : ''"
                   @click="iSearch()" style="width:100%" :disabled="instagram_result_loading" size="small">
          <div class="flex-row">
            検索
            <div class="loader--mini" v-if="instagram_result_loading"></div>
          </div>
        </el-button>
      </div>
    </div>
  </el-form>
</template>

<script>
const root = process.env.VUE_APP_API;
const resultCountAPI = root + "/api/search/result_count";
import sidemenuSuggestInfluencer from "./sidemenu_suggest_influencer";
import sidemenuSuggestKeyword from "./sidemenu_suggest_keyword";
import sidemenuCascader from "./sidemenu_cascader";
import { runCampaignGate } from '@/utils/campaignGate';

export default {
  name: "sidemenuInstagram",
  components: {
    sidemenuSuggestInfluencer,
    sidemenuSuggestKeyword,
    sidemenuCascader
  },
  data() {
    return {
      result_count: "",
      follower_marks: {
        500000: "500K+",
      },
      female_ratio_marks: {
        100: "100%",
      },
      age_marks: {
        55: "55+",
      },
      average_engagement_rate_marks: {
        10: "10%+",
      },
      score_marks: {
        100: "100",
      },
      average_video_play_count_marks: {
        500000: "500k+",
      },
      pr_rate_marks: {
        100: "100%",
      },
      mylist_instagram: [],
      actionId: +new Date(),
      requestId: +new Date(),
      next_cursor: "",
      language: "jp",
      noindex: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
    form() {
      return this.$store.state.form;
    },
    form_initial() {
      return this.$store.state.form_initial;
    },
    i_search() {
      return this.$store.state.i_search;
    },
    sidemenu_option() {
      return this.$store.state.sidemenu_option;
    },
    detail_option() {
      return this.$store.state.detail_option;
    },
    instagram_result_loading() {
      return this.$store.state.instagram_result_loading;
    },
    personTitleCascaderOptions() {
      return this.attributePropertyOption(this.sidemenu_option.attributes, 1);
    },
    specialtyCategoriesGenresCascaderOptions() {
      return this.attributePropertyOption(this.sidemenu_option.attributes, 2);
    },
    postFormatCascaderOptions() {
      return this.attributePropertyOption(this.sidemenu_option.attributes, 3);
    },
    categoryCascaderOptions() {
      return this.categoryOption(this.sidemenu_option.category_list);
    }
  },
  mounted() {
    this.form.followers_growth_rate_1 = true;
    this.form.followers_growth_rate_2 = true;
    this.form.followers_growth_rate_3 = true;
    this.form.followers_growth_rate_4 = true;
  },
  created() {
    if (!Array.isArray(this.form.pr_rate) || this.form.pr_rate.length !== 2) {
      this.$set(this.form, 'pr_rate', [0, 100]);
    }
  },
  methods: {
    resultCount() {
      this.noindex = false;
      this.$store.dispatch("instagram_result_loading", true);
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      const form = Object.assign({}, this.form);
      form.has_recent_post_1month = !!this.$store.state.recent_post_1month;
      params.append("params", JSON.stringify(form))
      this.axios
          .post(resultCountAPI, params, {requestId: this.requestId})
          .then((response) => {
            this.$store.dispatch("instagram_result_loading", false);
            this.result_count = response.data.result_count;
            this.noindex = response.data.noindex;
            // this.$store.dispatch("form", this.form);
            this.$store.dispatch("form", form);
          })
          .catch(() => {
            this.result_count = 0;
          });
    },
    async iSearch() {
      var form = Object.assign({}, this.form);
      form.has_recent_post_1month = !!this.$store.state.recent_post_1month;

      // 記号は「._()@#&･」及び全角のみ許可
      var reg = new RegExp(/[!"$%'*+,/:;<=>?@[\\\]^`{|}~]/g);
      // ローマ字1文字（大文字・小文字）だけの入力をNG
      var singleAlphaReg = new RegExp(/^[A-Za-z]$/);
      if (reg.test(form.account_name) || 
        reg.test(form.keyword) || 
        reg.test(form.exclude_keyword) ||
        singleAlphaReg.test(form.account_name) ||
        singleAlphaReg.test(form.keyword) ||
        singleAlphaReg.test(form.exclude_keyword)
      ) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "検索キーワードが短すぎる、もしくは使用できない記号が含まれています",
        });
        return;
      }

      // キャンペーンモーダルを表示（閉じたら続行）
      try {
        await runCampaignGate('partner_introduce');
      } catch (e) {/* no-op: モーダル取得に失敗しても検索は続行 */}

      this.$store.dispatch("instagram_result_loading", true);
      setTimeout(() => {
        this.$store.dispatch("instagram_result_loading", false);
      }, 10000)
      this.$store.dispatch("i_search", form);
      this.$router.push({
        name: "influencer",
        query: {actionId: (this.actionId += 1)},
        params: {sns_type: "instagram"},
      });
    },
    nameSearch() {
      const account_name = this.form.account_name;
      var form = Object.assign({}, this.form_initial);
      form.account_name = account_name;
      this.$store.dispatch("form", form);
      this.resultCount();
      this.iSearch();
    },
    resetParams() {
      this.$store.dispatch("recent_post_1month", false);
      this.$store.dispatch("form", Object.assign({}, this.form_initial)).then(() => {
        this.resultCount();
      });
    },
    resetKeyword() {
      this.form.account_name = "";
      this.form.keyword = "";
      this.form.exclude_keyword = "";
      this.resultCount();
    },
    ageTooltip(val) {
      if (val == 55) {
        return val + "+";
      } else if (val == 15) {
        return "〜" + val;
      } else {
        return val;
      }
    },
    showDetailOption() {
      this.$store.dispatch("showDetailOption");
    },
    attributePropertyOption(attributes, attributeId) {
      let options = [];

      if (!attributes) {
        return [{
          value: "all",
          label: "全て選択",
          children: options
        }];
      }

      attributes.forEach(innerArray => {
        innerArray.forEach(attribute => {
          if (attribute.attribute_id == attributeId) {
            attribute.properties.forEach(property => {
              options.push({
                label: property.property_name,
                value: property.property_id
              });
            });
          }
        });
      });

      return [{
        value: "all",
        label: "全て選択",
        children: options
      }];
    },
    categoryOption(category) {
      if (!category) {
        return [{
          value: "all",
          label: "全て選択",
          children: []
        }];
      }
      const options = category.map(item => ({
        label: item.label,
        value: item.value
      }));
      return [{
        value: "all",
        label: "全て選択",
        children: options
      }];
    }
  },
};
</script>
